module.exports = new __parcel__URL__("globe_protocol_etraining.1cecc70e.png").toString();